import { motion } from "framer-motion";

/**
 * MaskedReveal — renders each provided line inside an overflow-hidden box
 * and slides it up from below on mount / when in view.
 */
export function MaskedReveal({
  lines,
  className = "",
  delay = 0,
  stagger = 0.09,
  trigger = "mount",
  as = "div",
  lineClassName = "",
}) {
  const Wrap = as;

  const viewportProps =
    trigger === "view"
      ? { whileInView: "show", viewport: { once: true, amount: 0.3 } }
      : { animate: "show" };

  return (
    <Wrap className={className}>
      {lines.map((line, i) => (
        <span key={i} className="mask-line">
          <motion.span
            className={`mask-inner-motion ${lineClassName}`}
            initial={{ y: "110%" }}
            variants={{
              show: {
                y: 0,
                transition: {
                  duration: 1.05,
                  ease: [0.22, 1, 0.36, 1],
                  delay: delay + i * stagger,
                },
              },
            }}
            {...viewportProps}
            style={{ display: "block", willChange: "transform" }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Wrap>
  );
}

export default MaskedReveal;
